import { FaRegEdit } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import "../commonStyle.css";
import {
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UPDATE_SITES_LIST } from "../../store/actionTypes";
import { debounce } from "lodash";
import { MdAdd } from "react-icons/md";
import CustomPagination from "../customPagination";
import { BsSortAlphaDown, BsSortAlphaDownAlt } from "react-icons/bs";
import ProperSpinner from "../spinner/ProperSpinner";
import { getDateAndTimeFormatted } from "../../utils/commonFunctions";

/**
 * @function SiteTable
 * @description for Site Table
 * @returns JSX for Site Table
 */

const SitesTable = () => {
  const {
    sitesList,
    pageNo,
    totalPage,
    limit,
    searchKey,
    isLoading,
    sortOrder,
  } = useSelector((state) => state.SiteReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sortApplied, setSortApplied] = useState("siteName");
  const [inputValue, setInputValue] = useState(searchKey);
  const [show, setShow] = useState(false); // for Add sites Modal
  const modalHandler = () => {
    setShow(!show);
  };

  const sites = sitesList?.map((site) => {
    return {
      ...site,
      ...site.siteAddress,
    };
  });

  const updatePage = (page) => {
    dispatch({
      type: UPDATE_SITES_LIST,
      payload: { pageNo: page },
    });
  };

  const handlerSort = (sortBy) => {
    setSortApplied(sortBy);
    dispatch({
      type: UPDATE_SITES_LIST,
      payload: { sortBy: sortBy, sortOrder: sortOrder === 1 ? -1 : 1 },
    });
  };

  const pageLimitHandler = (e) => {
    const currLimit = e?.target?.value;
    dispatch({
      type: UPDATE_SITES_LIST,
      payload: { limit: currLimit, pageNo: 1 },
    });
  };

  const handleDebounceFn = (input) => {
    dispatch({
      type: UPDATE_SITES_LIST,
      payload: { searchKey: input, pageNo: 1 },
    });
  };
  const deBounceFn = useMemo(() => debounce(handleDebounceFn, 1000), []);

  const handleChange = (e) => {
    const text = e.target.value.replace(/[^a-zA-Z\s]/g, "").trimStart();
    setInputValue(text);
    if (text.length == 0 || text.length > 2) {
      deBounceFn(text);
    }
  };

  const handleClearInputField = () => {
    setInputValue("");
    deBounceFn("");
  };

  const renderTableBody = () => {
    return (
      <CTableBody>
        {sites?.length > 0 &&
          sites?.map((site, i) => {
            console.log("site :", site);
            const { siteName, addressLine1, city, postalCode, state, country } =
              site;

            const siteNameToShow = siteName
              ? siteName.length > 20
                ? siteName.substring(0, 20) + "..."
                : siteName
              : "N/A";
            const addressLine1ToShow = addressLine1
              ? addressLine1.length > 25
                ? addressLine1.substring(0, 25) + "..."
                : addressLine1
              : "N/A";
            const cityToShow = city
              ? city.length > 15
                ? city.substring(0, 15) + "..."
                : city
              : "N/A";
            const stateToShow = state
              ? state.length > 15
                ? state.substring(0, 15) + "..."
                : state
              : "N/A";
            const countryToShow = country
              ? country.length > 15
                ? country.substring(0, 15) + "..."
                : country
              : "N/A";
            const postalCodeToShow = postalCode
              ? postalCode.length > 10
                ? postalCode.substring(0, 10) + "..."
                : postalCode
              : "N/A";

            return (
              <CTableRow
                key={i}
                className="table-data-text"
                // onClick={() => navigate(`/sites/${site?._id}`)}
              >
                <CTableDataCell className=" table-heading-5-cell">
                  {(pageNo - 1) * limit + i + 1}
                </CTableDataCell>
                <CTableDataCell
                  onClick={() => navigate(`/sites/${site._id}`)}
                  title={siteName}
                >
                  {siteNameToShow}
                </CTableDataCell>
                <CTableDataCell title={addressLine1}>
                  {addressLine1ToShow}
                </CTableDataCell>
                <CTableDataCell title={city}>{cityToShow}</CTableDataCell>
                {/* <CTableDataCell title={state}>{stateToShow}</CTableDataCell> */}
                <CTableDataCell title={country}>{countryToShow}</CTableDataCell>
                <CTableDataCell title={postalCode}>
                  {postalCodeToShow}
                </CTableDataCell>
                <CTableDataCell>
                  {getDateAndTimeFormatted(site?.updatedAt)}
                </CTableDataCell>
                <CTableDataCell>
                  {getDateAndTimeFormatted(site?.createdAt)}
                </CTableDataCell>
                <CTableDataCell className="text-center ">
                  {/* <FaUserEdit
                    className="actions-icons cursor-pointer"
                    onClick={() => navigate(`/sites/update-site/${site._id}`)}
                  /> */}
                  <FaRegEdit
                    className="actions-icons  cursor-pointer"
                    onClick={() => navigate(`/sites/update-site/${site._id}`)}
                  />
                </CTableDataCell>
              </CTableRow>
            );
          })}
      </CTableBody>
    );
  };

  const renderPagination = () => {
    return (
      <CustomPagination
        limit={limit}
        limitHanlder={pageLimitHandler}
        pageNo={pageNo}
        pageChangeHanlder={updatePage}
        totalPage={totalPage}
      />
    );
  };

  const renderNoDataFound = () => {
    if (isLoading) {
      return (
        <div className="ndf-container">
          <h3 className="ndf-heading">
            {/* {"No"} */}
            <span>{" Fetching sites "}</span> {"..."}
          </h3>
        </div>
      );
    }
    return (
      <div className="ndf-container">
        <h3 className="ndf-heading">
          {"No"}
          <span>{" Sites "}</span> {"available !!!"}
        </h3>
      </div>
    );
  };

  const renderView = () => {
    return (
      <div>
        <div className="table-header-container">
          <h3 className="w-50 mb-0 text-primary">{"Sites List"}</h3>
          <div className="d-flex justify-content-end align-items-center gap-1">
            {/* Search section */}
            <CInputGroup className="" style={{ width: "300px" }} size="sm">
              <CInputGroupText className="cursor-pointer">
                <FaSearch />
              </CInputGroupText>
              <CFormInput
                value={inputValue}
                name="text"
                onChange={handleChange}
                placeholder="Search site name"
              />

              {inputValue && (
                <CInputGroupText
                  className="cursor-pointer"
                  onClick={handleClearInputField}
                >
                  <RxCross2 />
                </CInputGroupText>
              )}
            </CInputGroup>

            {/* Filter section */}
            {/* <div className="border rounded-1 px-2 cursor-pointer filter-icon ">
              <FiFilter className="disabled-icons" />
            </div> */}

            <div
              className="btn btn-primary btn-sm add-btn add-btn-container"
              onClick={() => navigate("/sites/add-site")}
            >
              <span>{"Add"}</span>
              <span className="add-icon">
                <MdAdd />
              </span>
            </div>
          </div>
        </div>
        <CTable hover responsive>
          <CTableHead className="text-nowrap border">
            <CTableRow>
              <CTableHeaderCell className="bg-body-tertiary text-center table-heading-5-cell">
                S. No.
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "siteName" ? "sort-highlight" : ""}`}
              >
                {"Site Name"}
                <span onClick={() => handlerSort("siteName")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "siteAddress.addressLine1" ? "sort-highlight" : ""}`}
              >
                {"Address"}
                <span onClick={() => handlerSort("siteAddress.addressLine1")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-10-cell ${sortApplied === "siteAddress.city" ? "sort-highlight" : ""}`}
              >
                {"City"}
                <span onClick={() => handlerSort("siteAddress.city")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              {/* <CTableHeaderCell className="bg-body-tertiary table-heading-10-cell">
                {"State"}
                <span onClick={() => handlerSort("siteAddress.state")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell> */}
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-10-cell ${sortApplied === "siteAddress.country" ? "sort-highlight" : ""}`}
              >
                {"Country"}
                <span onClick={() => handlerSort("siteAddress.country")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-10-cell ${sortApplied === "siteAddress.postalCode" ? "sort-highlight" : ""}`}
              >
                {"Postal Code"}
                <span onClick={() => handlerSort("siteAddress.postalCode")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "updatedAt" ? "sort-highlight" : ""}`}
              >
                {"Updated At"}
                <span onClick={() => handlerSort("updatedAt")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell
                className={`bg-body-tertiary table-heading-15-cell ${sortApplied === "createdAt" ? "sort-highlight" : ""}`}
              >
                {"Created At"}
                <span onClick={() => handlerSort("createdAt")}>
                  {sortOrder === 1 ? (
                    <BsSortAlphaDown className="sort-icons cursor-pointer" />
                  ) : (
                    <BsSortAlphaDownAlt className="sort-icons cursor-pointer" />
                  )}
                </span>
              </CTableHeaderCell>
              <CTableHeaderCell className="bg-body-tertiary table-heading-5-cell text-center">
                {"Actions"}
              </CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          {isLoading ? <ProperSpinner /> : renderTableBody()}
        </CTable>
        {(sitesList?.length >= 5 || pageNo > 1) && renderPagination()}
        {/* {!isLoading && sitesList?.length === 0 && renderNoDataFound()} */}
        {(isLoading || sitesList?.length == 0) && renderNoDataFound()}
      </div>
    );
  };
  return <div>{renderView()}</div>;
};

export default SitesTable;
